export default __webpack_public_path__ + "assets/veger.0037451c.png";